import { NavLink, Outlet } from "react-router-dom";
import Layout from "layout/Layout";

const tabs = [
  { name: "Dashboard", path: "/finance", end: true },
  { name: "Sales", path: "/finance/sales" },
  { name: "Expense", path: "/finance/expense" },
  { name: "Expense Analytics", path: "/finance/expense-analytics" },
  { name: "Commissions", path: "/finance/commissions" },
];

const tabClassName = ({ isActive }) =>
  `px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${
    isActive
      ? "bg-primary-600 text-white border-primary-600"
      : "bg-white text-gray-600 border-gray-300 hover:border-primary-300"
  }`;

export default function FinanceLayout() {
  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Finance</h1>

      <nav className="mb-6 flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={tabClassName}
          >
            {tab.name}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </Layout>
  );
}
